<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="5">
                    <rkm-form-input
                        label="Descrição"
                        v-model="model.descricao"
                        :validations="validations.descricao"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Limite inferior mínimo"
                        v-model="model.limiteInferior"
                        v-money="money"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Limite superior máximo"
                        v-model="model.limiteSuperior"
                        :validations="model.limiteInferior ? validations.limiteSuperior : {}"
                        v-money="money"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Unidade"
                        text-field="descricao"
                        value-field="id"
                        v-model="model.unidadeId"
                        :options="data.form.composicaoUnidade"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Referência"
                        v-model="model.referencia"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        label="Tipo idade"
                        text-field="nome"
                        value-field="id"
                        v-model="model.tipoIdadeId"
                        :options="data.form.composicaoTipoIdade"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Idade inicial"
                        number
                        v-model="model.idadeInicial"
                        :validations="validations.idadeInicial"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Idade final"
                        number
                        v-model="model.idadeFinal"
                        :validations="validations.idadeFinal"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Sexo"
                        text-field="descricao"
                        value-field="id"
                        v-model="model.sexoId"
                        :options="data.form.composicaoSexo"
                        default-option-text="AMBOS"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Tipo de resultado"
                        text-field="descricao"
                        value-field="id"
                        v-model="model.tipoResultadoId"
                        :validations="validations.tipoResultadoId"
                        :options="data.form.composicaoTipoResultado"
                        show-default-option
                        @change="setFormula"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Fórmulas"
                        text-field="nome"
                        value-field="id"
                        v-model="model.formulaId"
                        :options="data.form.formulas"
                        :disabled="model.tipoResultadoId && model.tipoResultadoId !== this.enums.tipoResultado.FORMULA"
                        :validations="model.tipoResultadoId == this.enums.tipoResultado.FORMULA ?
                            validations.formulaId : {}"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        label="Casas decimais"
                        text-field="descricao"
                        value-field="id"
                        v-model="model.casaDecimalId"
                        :validations="model.tipoResultadoId == this.enums.tipoResultado.FORMULA
                            || model.tipoResultadoId == this.enums.tipoResultado.NUMERICO
                            ? validations.casaDecimalId : {}"
                        :options="data.form.composicaoCasaDecimal"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Visível"
                        v-model="model.visivel"
                        :validations="validations.visivel"
                        :options="data.form.composicaoVisivel"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col cols="auto">
                    <rkm-form-checkbox
                        v-model="model.valorAbsoluto"
                        @change="handleResultado"
                    >
                        Valor absoluto
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-form-checkbox
                        v-model="model.resultado"
                        @change="handleValorAbsoluto"
                    >
                        Resultado
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="12" class="mt-2">
                    <rkm-text-editor
                        label="Referência especial"
                        v-model="model.referenciaEspecial"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

// Enums.
import tipoResultado from '@/enums/parametrizacao/composicaoTipoResultado'

//Directives
import { VMoney } from 'v-money'

export default {
    directives: {
        money: VMoney
    },
    computed: {
        validations() {
            return {
                descricao: {
                    min: 3,
                    max: 100,
                },
                idadeInicial: {
                    required: this.model.tipoIdadeId ? true : false,
                },
                idadeFinal: {
                    min_value: this.model.idadeInicial ? this.model.idadeInicial : 0,
                    required: this.model.tipoIdadeId ? true : false,
                },
                limiteSuperior: {
                    min_value: this.model.limiteInferior ? this.model.limiteInferior : 0,
                    required: true,
                },
                tipoResultadoId: {
                    required: true,
                },
                casaDecimalId: {
                    required: true,
                },
                visivel: {
                    required: true,
                },
                formulaId: {
                    required: true,
                },
            }
        },
        hasIndex() {

            return this.index !== null
        },
    },
    created() {

        this.load()
    },
    data: () => ({
        model: {
            id: null,
            descricao: '',
            limiteInferior: null,
            limiteSuperior: null,
            unidadeId: null,
            unidade: '',
            referencia: '',
            tipoIdadeId: null,
            tipoIdade: '',
            formulaId: null,
            idadeInicial: null,
            idadeFinal: null,
            sexoId: null,
            sexo: '',
            tipoResultadoId: null,
            tipoResultado: '',
            casaDecimalId: null,
            visivel: null,
            referenciaEspecial: '',
            valorAbsoluto: null,
            resultado: null,
            lista: [],
            variavel: [],
            composicao: [],
            textoPronto: [],
        },
        enums: { tipoResultado },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
    }),
    mixins: [ repository, stringCase, object, error ],
    props: {
        data: { type: Object, required: true },
        item: { type: Object, default: null },
        index: { type: Number, default: null },
    },
    methods: {
        load() {

            if (this.item) {

                this.model.id = this.item.id,
                this.model.descricao = this.item.descricao,
                this.model.limiteInferior = this.item.limiteInferior,
                this.model.limiteSuperior = this.item.limiteSuperior,
                this.model.unidadeId = this.item.unidadeId,
                this.model.referencia = this.item.referencia,
                this.model.tipoIdadeId = this.item.tipoIdadeId,
                this.model.formulaId = this.item.formulaId,
                this.model.idadeInicial = this.item.idadeInicial,
                this.model.idadeFinal = this.item.idadeFinal,
                this.model.sexoId = this.item.sexoId,
                this.model.tipoResultadoId = this.item.tipoResultadoId,
                this.model.casaDecimalId = this.item.casaDecimalId,
                this.model.visivel = this.item.visivel,
                this.model.valorAbsoluto = this.item.valorAbsoluto,
                this.model.resultado = this.item.resultado,
                this.model.referenciaEspecial = this.item.referenciaEspecial
                this.model.lista = this.item.lista
                this.model.variavel = this.item.variavel
            }
        },
        add() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    const composicao = this.clone(this.model)

                    const unidade = this.data.form.composicaoUnidade.find(u => u.id === this.model.unidadeId)
                    const sexo = this.data.form.composicaoSexo.find(u => u.id === this.model.sexoId)
                    const resultado = this.data.form.composicaoTipoResultado.find(u => u.id === this.model.tipoResultadoId)
                    const idade = this.data.form.composicaoTipoIdade.find(u => u.id === this.model.tipoIdadeId)

                    if (this.model.unidadeId) {
                        composicao.unidade = unidade.descricao
                    } else {
                        composicao.unidade = '-'
                    }

                    composicao.sexo = sexo ? sexo.descricao : 'AMBOS'
                    composicao.tipoResultado = resultado.descricao
                    composicao.tipoIdade = idade ? idade.nome : '-'

                    if (this.hasIndex) {

                        const objId = this.data.model.composicao.findIndex((obj => obj.id == this.item.id));

                        this.$set(this.data.model.composicao, objId, composicao)
                    }
                    else {

                        composicao.id = this.uniqueId('composicao' + new Date().getTime())

                        this.data.model.composicao.push(composicao)
                    }

                    this.resetForm()
                    this.$emit('save')
            })
        },
        validate() {

            return this.$refs.Form.validate()
        },
        resetForm() {

            this.model.exameId = null
            this.model.descricao = ''
            this.model.limiteInferior = null
            this.model.limiteSuperior = null
            this.model.unidadeId = null
            this.model.referencia = ''
            this.model.tipoIdadeId = null
            this.model.formulaId = null
            this.model.idadeInicial = null
            this.model.idadeFinal = null
            this.model.sexoId = null
            this.model.tipoResultadoId = null
            this.model.casaDecimalId = null
            this.model.visivel = null
            this.model.referenciaEspecial = ''
            this.model.resultado = false
            this.model.valorAbsoluto = false

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setFormula() {

            this.model.formulaId = null
        },
        handleResultado() {
            this.model.resultado = false
        },
        handleValorAbsoluto() {
            this.model.valorAbsoluto = false
        }
    },
}
</script>